import styled from 'styled-components';
import { LabelInput } from './LabelInput';
import { getThemeColor } from 'style-utils/theme/utils/getThemeColor';

export const computeDataShrinkValue = (
  value: string | number | readonly string[] | undefined,
) => {
  if (
    typeof value === 'undefined' ||
    value === '' ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return undefined;
  }
  return '1';
};

export const Input = styled.input.attrs(({ value }) => ({
  'data-shrink': computeDataShrinkValue(value),
}))`
  display: block;
  width: 100%;
  height: 4rem;
  background: transparent;
  color: ${getThemeColor('textPrimary')};
  border: 2px solid ${getThemeColor('fieldColor')};
  border-radius: 0.4rem;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  line-height: 1.857;
  font-size: 1.6rem;
  box-shadow: none;
  padding: 0 0.9rem 0 0.9rem;
  /* Remove box-shadow inside input */

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Hides the credentials indicator in safari. */
  &::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    right: 0;
  }

  &::placeholder {
    color: transparent;
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border-color: ${getThemeColor('fieldFocusColor')};
    &::placeholder {
      color: ${getThemeColor('fieldColor')};
    }
  }

  &:focus ~ ${LabelInput}, &[data-shrink='1'] ~ ${LabelInput} {
    top: -1rem;
    padding: 0 0.4rem;
    font-size: 1.2rem;
    line-height: 2.2rem;
    font-weight: 500;
    background: #ffffff;
  }

  &:focus ~ ${LabelInput} {
    color: ${getThemeColor('fieldFocusColor')};
  }

  &[disabled] {
    -webkit-text-fill-color: ${getThemeColor('fieldDisabledColor')};
    -webkit-opacity: 1;
    opacity: 1;
    color: ${getThemeColor('fieldDisabledColor')};
  }
`;
